// src/components/shared/Input.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(1)};

  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.inputGray};
  }

  label {
    position: absolute;
    top: 5%;
    left: 45px;  /* Padding to align with the input's left padding */
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.colors.surface};  /* Background color to overlap input's border */
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;  /* Add some padding to prevent label from cutting off */
    pointer-events: none;  /* Prevents the label from being clicked */

  }

  input {
    width: 100%;
    padding: 18px;
    padding-left: 45px;  /* Leave space for the icon */
    margin: 5px 0;
    font-size: 1.2em;
    border: 1px solid ${(props) => props.theme.colors.inputGray};
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
    outline: none;

    &:focus {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      
      color: ${(props) => props.theme.colors.textPrimary};  /* Change label color when input is focused */
      font-size: 14px;
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.inputGray};
    }
  }

  .error-message {
    color: ${(props) => props.theme.colors.error};
    font-size: 1.1em;
    margin-top: 5px;
  }
`;

const Input = ({ label, icon, error, ...props }) => {
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    if (props.value && props.value.length > 0) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }
  }, [props.value]);

  return (
    <InputWrapper error={error}>
      {icon}
      <input {...props} />
      <label className={hasValue ? 'active' : ''}>{label}</label>
      {error && <div className="error-message">{error}</div>}
    </InputWrapper>
  );
};

export default Input;
